module.exports = __webpack_public_path__ + "static/monzo-1@2x-b35e4ad99b97ba07787654ae934506e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/financial-services/monzo-1@2x.jpg
// module id = 2633
// module chunks = 47877783677342